import LOASourceEnum from '@constants/enums/loa/source';
import LOAStatusEnum from '@constants/enums/loa/status';
import LOATypeEnum from '@constants/enums/loa/type';

import i18n from '@plugins/i18n';

import { Collection, ProviderInvestor, Provider, FundManager, Investor } from '@/models';

export class ProviderInvestorRelationshipCollection extends Collection {
    static type = 'ProviderInvestorRelationshipCollection';
    static endpoint = Provider.api.getInvestorRelationships;
    static model = ProviderInvestor;

    static fields() {
        return {
            ...super.fields(),

            provider_id: this.string(null).nullable(),
            provider: this.belongsTo(Provider, 'provider_id'),

            fund_manager_id: this.string(null).nullable(),
            fund_manager: this.belongsTo(FundManager, 'fund_manager_id'),

            investor_id: this.string(null).nullable(),
            investor: this.belongsTo(Investor, 'investor_id')
        };
    }

    get preset_filters() {
        let filters = {};

        if (this.provider_id) {
            filters.provider_id = this.filterOperator('is') + ':' + this.provider_id;
        }

        if (this.fund_manager_id) {
            filters.fund_manager_id = this.filterOperator('is') + ':' + this.fund_manager_id;
        }

        if (this.investor_id) {
            filters.investor_id = this.filterOperator('is') + ':' + this.investor_id;
        }

        return filters;
    }

    get default_headers() {
        return ['investor_name', 'loa_status', 'loa_source', 'loa_type', 'loa_requested_at', 'loa_completed_at'];
    }

    get headers() {
        return [
            this.createHeader('investor_name', i18n.tc('investor'), {
                filterable: true,
                sortable: true,
                width: '18rem',
                minWidth: '18rem',
                path: 'investor.name'
            }),
            this.createHeader('loa_status', i18n.t('loa') + ' ' + i18n.t('status'), {
                filterable: true,
                sortable: true,
                width: '10rem',
                format: 'enum',
                enum: LOAStatusEnum,
                enumA11yKey: 'enums.loa_status',
                enumTypes: {
                    [LOAStatusEnum.MISSING]: 'warning',
                    [LOAStatusEnum.PENDING]: 'special',
                    [LOAStatusEnum.COMPLETED]: 'success'
                }
            }),
            this.createHeader('loa_source', i18n.t('loa') + ' ' + i18n.t('source'), {
                filterable: true,
                sortable: true,
                width: '10rem',
                format: 'enum',
                enum: LOASourceEnum,
                enumA11yKey: 'enums.loa_source',
                enumTypes: {
                    [LOASourceEnum.GENERATED]: 'primary',
                    [LOASourceEnum.UPLOADED]: 'special'
                }
            }),
            this.createHeader('loa_type', i18n.t('loa') + ' ' + i18n.t('type'), {
                filterable: true,
                sortable: true,
                width: '10rem',
                format: 'enum',
                enum: LOATypeEnum,
                enumA11yKey: 'enums.loa_type',
                enumTypes: {
                    [LOATypeEnum.APPLICATION]: 'primary',
                    [LOATypeEnum.INVESTOR_LOA]: 'primary',
                    [LOATypeEnum.OTHER]: 'grey'
                }
            }),
            this.createHeader('loa_requested_at', i18n.t('loa') + ' ' + i18n.t('requested_at'), {
                filterable: true,
                sortable: true,
                format: 'date',
                width: '12rem'
            }),
            this.createHeader('loa_completed_at', i18n.t('loa') + ' ' + i18n.t('signed_at'), {
                filterable: true,
                sortable: true,
                format: 'date',
                width: '13rem'
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '17rem',
                persistent: true
            })
        ];
    }
}

export default ProviderInvestorRelationshipCollection;
